module.exports = __webpack_public_path__ + "static/hcl-faf0a2aa0509769ae72eb1a5e0ea1036.png";